import styled from 'styled-components';
import { breakpoints } from '../../../../../styles/theme';
import { StockModelCardHeaderStyled } from '../StockModelCardHeaderStyled';
import { rem } from 'polished';

export const StockModelCardHeaderStyledAP = styled(StockModelCardHeaderStyled)``;
